import baseApi from './RootBaseApi';
import {
  ChangePasswordRequest,
  ChangePasswordResponse,
  ForgotPasswordRequest,
  ForgotPasswordResponse,
  LoginRequest,
  LoginResponse,
  ResetPasswordRequest,
  ResetPasswordResponse,
  UserPermissionsResponse,
} from '@/types/auth.types';

export const AuthService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: (user) => {
        return {
          url: 'auth/signin',
          method: 'POST',
          data: user,
        };
      },
      transformResponse: (response: LoginResponse) => response,
    }),

    getUserPermissions: builder.query<
      UserPermissionsResponse,
      { lang?: string }
    >({
      query: (params) => ({
        url: 'permissions/user-roles-permissions',
        method: 'GET',
        params,
      }),
    }),

    logout: builder.mutation<void, void>({
      query: () => ({
        url: 'auth/logout',
        method: 'POST',
        data: {},
      }),
    }),

    forgotPassword: builder.mutation<
      ForgotPasswordResponse,
      ForgotPasswordRequest
    >({
      query: (data) => ({
        url: 'auth/forgot-password',
        method: 'POST',
        data,
      }),
      transformResponse: (response: ForgotPasswordResponse) => response,
    }),

    resetPassword: builder.mutation<
      ResetPasswordResponse,
      ResetPasswordRequest
    >({
      query: ({ token, password }) => ({
        url: `auth/reset-password/${token}`,
        method: 'POST',
        data: { password },
      }),
      transformResponse: (response: ResetPasswordResponse) => response,
    }),

    changePassword: builder.mutation<
      ChangePasswordResponse,
      ChangePasswordRequest
    >({
      query: (data) => ({
        url: 'auth/change-password',
        method: 'POST',
        data: {
          oldPassword: data.oldPassword,
          newPassword: data.newPassword,
        },
      }),
      transformResponse: (response: ChangePasswordResponse) => response,
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          console.error('Password change failed:', error);
        }
      },
    }),
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useChangePasswordMutation,
  useGetUserPermissionsQuery,
  useLazyGetUserPermissionsQuery,
} = AuthService;
